import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _AnswerPoints;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@instructure/quiz-common';
import { Text } from '@instructure/ui-text';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import NumberInput from '@instructure/quiz-number-input';
import { jsx } from '@instructure/emotion';
import { v4 as uuid } from 'uuid';
import t from '@instructure/quiz-i18n/es/format-message';
function pointsAsFloat(pointsString) {
  return parseFloat(pointsString) || 0;
}
function countDecimals(normalizedPointsString) {
  if (!normalizedPointsString) return 0;
  // eslint-disable-next-line no-unused-vars
  var _normalizedPointsStri = normalizedPointsString.split('.'),
    _normalizedPointsStri2 = _slicedToArray(_normalizedPointsStri, 2),
    _ = _normalizedPointsStri2[0],
    decimals = _normalizedPointsStri2[1];
  return decimals ? decimals.length : 0;
}
var THREE_DECIMAL_PLACES_WIDTH = '6.1rem';
var AnswerPoints = /*#__PURE__*/function (_Component) {
  function AnswerPoints() {
    var _this;
    _classCallCheck(this, AnswerPoints);
    _this = _callSuper(this, AnswerPoints, arguments);
    _defineProperty(_this, "handleChange", function (event, points, normalizedPoints) {
      // do not allow more than 3 decimals
      if (_this.props.onAnswerPointsChange && countDecimals(normalizedPoints) <= 3) {
        var pointsFloat = pointsAsFloat(normalizedPoints);
        if (pointsFloat !== _this.props.answerPoints) {
          _this.props.onAnswerPointsChange(pointsFloat);
        }
        _this.setState({
          points: points,
          normalizedPoints: normalizedPoints
        });
      }
    });
    _defineProperty(_this, "handleBlur", function (event) {
      if (!_this.state.normalizedPoints) {
        _this.setState({
          points: '0'
        });
      }
    });
    var answerPoints = _this.props.answerPoints;
    var _points = answerPoints == null ? '' : answerPoints;
    _this.state = {
      points: _points,
      normalizedPoints: _points
    };
    _this.numberInputLabelId = uuid();
    return _this;
  }
  _inherits(AnswerPoints, _Component);
  return _createClass(AnswerPoints, [{
    key: "render",
    value: function render() {
      var currentPointsValue = this.state.points;
      return jsx(Flex, {
        direction: "row",
        alignItems: "center",
        gap: "x-small"
      }, jsx(NumberInput, {
        name: this.props.name,
        value: currentPointsValue,
        renderLabel: jsx(ScreenReaderContent, null, t('Points Possible')),
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        width: THREE_DECIMAL_PLACES_WIDTH /* wide enough to fit 3 decimal places (i.e. 8.888) */,
        "aria-describedby": this.numberInputLabelId,
        "data-automation": "sdk-points-possible-".concat(this.props.name, "-input"),
        "aria-valuetext": "".concat(currentPointsValue, " ").concat(t('Pts'))
      }), jsx(Flex.Item, null, jsx(Text, {
        id: this.numberInputLabelId,
        color: "primary",
        size: "small"
      }, t('Pts'))));
    }
  }]);
}(Component);
_AnswerPoints = AnswerPoints;
_defineProperty(AnswerPoints, "displayName", 'AnswerPoints');
_defineProperty(AnswerPoints, "componentId", "Quizzes".concat(_AnswerPoints.displayName));
_defineProperty(AnswerPoints, "propTypes", {
  name: PropTypes.string,
  answerPoints: PropTypes.number,
  onAnswerPointsChange: PropTypes.func,
  styles: PropTypes.object
});
_defineProperty(AnswerPoints, "defaultProps", {
  name: void 0,
  answerPoints: void 0,
  onAnswerPointsChange: void 0
});
export { AnswerPoints as default };